import { computed } from '@vue/composition-api'
import store from '@/store'

export default function useMyStore() {
  const currentUser = computed({
    get: () => store.state.auth.currentUser,
    set: v => {
      store.commit('auth/UPDATE_CURRENT_USER', { currentUser: v })
    },
  })

  const token = computed({
    get: () => store.state.auth.token,
    set: v => {
      store.commit('auth/UPDATE_CURRENT_USER_TOKEN', { token: v })
    },
  })

  const userType = computed({
    get: () => store.state.auth.userType,
    set: v => {
      store.commit('auth/UPDATE_USER_TYPE', { userType: v })
    },
  })

  const isAuthenticated = computed({
    get: () => store.state.auth.isAuthenticated,
    set: v => {
      store.commit('auth/UPDATE_AUTHENTICATED', { isAuthenticated: v })
    },
  })

  const acl = computed({
    get: () => store.state.auth.acl,
    set: v => {
      store.commit('auth/SET_ACL', { acl: v })
    },
  })

  const logout = () => {
    store.commit('auth/unsetAuth')
  }

  return {
    currentUser,
    token,
    isAuthenticated,
    userType,
    acl,
    logout,
  }
}
